import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const dropzoneFn = /* @__PURE__ */ createRecipe('Dropzone', {}, [])

const dropzoneVariantMap = {}

const dropzoneVariantKeys = Object.keys(dropzoneVariantMap)

export const dropzone = /* @__PURE__ */ Object.assign(memo(dropzoneFn.recipeFn), {
  __recipe__: true,
  __name__: 'dropzone',
  __getCompoundVariantCss__: dropzoneFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: dropzoneVariantKeys,
  variantMap: dropzoneVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, dropzoneVariantKeys)
  },
  getVariantProps: dropzoneFn.getVariantProps,
})